module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_3",
      "title": "3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "BodoniBertholdBQ-Medium"
  }, [_vm._v("An Education")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CAU"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Amy Maclin")])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("For seventeen years, I spent most of my waking hours in school doodling. I learned the types of clouds and what happens to a banana when you put it in liquid nitrogen. But there were never any classes on how to live. I wanted to know what we need to do to be happy, and how to make love last, and why we should keep washing the dishes when "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("we’re all going to die someday.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In the absence of formal instruction, I became a self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("help geek. My teenage raids on my mother’s book closet taught me about erroneous zones and bad things that happened to good people and how Helen Gurley Brown was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Having It All,")]), _vm._v(" which had me eagerly awaiting the prurient thrills of adulthood. (Still waiting.) After college I entered a diaphanous phase of Jungian archetypes; I greeted "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_4",
      "title": "4"
    }
  }, [_vm._v("the millennium with Buddhist titles about the essentialness of emptiness"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("each one beautifully executed yet unsatisfying, like trendy foam food.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As I hurtled into my forties, I knew I was lucky"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("I had a good husband, friends, interesting work"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("but I worried that I didn’t deserve it all, or that I was messing it up, or that everything would be taken away. I’d been an outwardly cheerful kid who was desperate to keep everyone happy but lay awake wondering, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("What if the world ends?")]), _vm._v(" Now I was an outwardly cheerful adult who did the same. I had the rest of my life to figure things out, but the rest of my life didn’t seem like a long time anymore. Some things were changing rapidly (the topography of my skin, the resilience of my knees), and some things wouldn’t be changing at all (I’d always be a sensitive tub of goo, and I’d never be a mother"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("my choice, but so final). I still hadn’t grown up, and yet I was growing old.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It felt obscene to gnaw on my fears and regrets, because I was "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("loved.")]), _vm._v(" How could I feel adrift in a universe where I had an embarrassment of riches? I had my husband, who held me when I was angry or sick or both. When I wept about the future"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("mine or our swiftly tilting planet’s"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("he’d "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_5",
      "title": "5"
    }
  }, [_vm._v("say things that took my ungrateful breath away, like “But you’ll always have me.” The trouble with being forty"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("four years old was that I knew I might not.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("No one can think about this stuff all the time and still live in the world, so I got therapy and figured I’d just grimace and bear it. But then I found out that there really is a School of Life.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Headquartered in a London storefront, the school offers courses on the essential human conundrums, such as How to Choose a Partner or How to Make Your Mind Up. Founder Alain de Botton, writer of such cheekily pop"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("philosophical books as "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("How Proust Can Change Your Life,")]), _vm._v(" wanted to create a place where ordinary people could illuminate their ordinary problems with insights gathered from literature or philosophy"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("Tolstoy on family happiness, Thoreau on solitude. “It’s tragic that everyone thinks they have to work everything out for themselves, because they don’t,” says de Botton. “No more than we have to work out physics for ourselves.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Since childhood I’ve been fascinated by stories about hidden worlds lurking behind some ordinary door, like Narnia. The School of Life seemed magical that way, "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_6",
      "title": "6"
    }
  }, [_vm._v("tucked across the street from a place that sold Union Jack umbrellas (a number of which I bought and then forgot in pubs all over central London). Above the dark blue door, stenciled yellow letters promised "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("GOOD IDEAS FOR EVERYDAY LIFE.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Inside, the requisite bookstore was airy and light, customers murmuring in English and Japanese, someone gently placing the lid on a china teapot. It was the way I wanted things to be in my head. I promptly bought a “Utopia Candle,” inspired by Thoreau’s Walden Pond"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v(",")]), _vm._v(" with a top note of wild berries, and a “Psychoanalytic Pencil Set,” each one engraved with a psychological term (e.g., "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("DEFENCE MECHANISM")]), _vm._v("). It was a boutique of self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("help, and I was grooving on it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I couldn’t pass up "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("How to Develop Emotional Health,")]), _vm._v(" 141 pages long and pop"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("art pink with one upturned curve on the cover; look again and you realize it’s a smile. This is the school’s brand of wink"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("wink, nudge"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("nudge message: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("We know that")]), _vm._v(" you "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("know it’s ridiculous to think a book that’s half an inch thick could tell you everything about “how to develop emotional health.” But we know you wish")]), _vm._v(" "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_7",
      "title": "7"
    }
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("it could. We wish it could, too. The absurdity of it all! Together, we’ll figure out what we can.")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Even the teachers embodied this roll"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("up"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("your"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("sleeves whimsy: Cathy, who said her creative muse had the fearlessness of Vivienne Westwood and the patience of Mr. Miyagi from "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Karate Kid;")]), _vm._v(" John"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("Paul, who spent a year making his own clothes and wrote a book about it called "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sew Your Own.")]), _vm._v(" As for the attendees, they ran the gamut: tattooed creative types, young mothers, thirty"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("ish guys in football jerseys, pillowy older ladies whom I hoped would call me “Ducky.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’ve always been privately appalled by group therapy. All those judgmental strangers in chairs circled like one of the descending rings of hell. However, at The School of Life I found my fellow students funny and charming, prone to saying things like “People with a high degree of self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("mastery and self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("knowledge"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("I envy those bastards.” In How to Stay Calm, everyone shared the triggers of their anxiety and rage, like transatlantic flights or the ex"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("husband who’s “an absolute knob.” None of it applied to me, and I wrote smugly in my notes, “No big revelations "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_8",
      "title": "8"
    }
  }, [_vm._v("here.” Then a fifty"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("something man with the tiniest hole in his wool sweater said with urgency, “What if your anxiety is more low"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("level but … chronic? Since I turned forty, I’ve been walking around with it all the time.” I sat up straighter then. I knew this song by heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s not that I’m constantly agonizing over the passing of time. It’s more intermittent than that. I’ll just be looking into a mirror with my head tilted a tiny bit and I’ll see it"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("the skin that pulls at the hollow of my neck, so thin and delicate that I might as well be made of gauze. Then the fear slips up from behind and puts me in a choke hold. But when I look around at the bright world with its crisp edges, everyone is joking about wrinkles, each passing birthday that, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("hardy-har,")]), _vm._v(" “beats the alternative!” It was a balm to see another human being carrying the same burden I did, this middle"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("manager type who could be standing behind me in a sandwich line. I fought the urge to turn to him and shout, “ME TOO!” I didn’t think I’d ever fully felt the power of those two words before.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("When I caught up with him at the break, he said, “What did you do for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("your")]), _vm._v(" fortieth? I just went into a cave.” I brightened. “Oh, a "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("cave")]), _vm._v("! Where?” He said, “Er, not an "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_9",
      "title": "9"
    }
  }, [_vm._v("actual cave. I just stayed in my apartment.” I asked, “It gets better, though, right?” He looked at me kindly and answered, “Somewhat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("At the beginning of each class, we were asked to write a newspaper headline about why we were there. In How to Balance Work with Life, our example was "), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("PRESSURIZED MANAGER DESPERATE FOR DATING TIME")]), _vm._v("! I put pen to paper"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("and stopped. How could I know myself so little when I thought about me constantly? Had I been thinking, or was it just ruminating, the thing a cow does when she chews her regurgitated feelings"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("I mean, food?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The truth was, I had a secret shame. In all those self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("help books I read, I never did the exercises. They would have just slowed me down, and I needed to move on to the next book because my self needed a lot of help. When John"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("Paul asked us to write about how we hid our work identities at home and our home identities at work, I felt a squirming eighth"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("grade restlessness and mentally willed him not to call on me. This is the downside of being in school: Someone in charge forces you to work. John"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("Paul reminded us that we had to make a conscious effort to find time for the things that mattered. And then he called on "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_10",
      "title": "10"
    }
  }, [_vm._v("me. “What could you lose in order to gain?” he asked. I said, “Watch less TV?”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In college I had a sadistic English professor who had been forced to postpone her own education because she’d been busy having five children, as she frequently and bitterly reminded us. We were children ourselves, who had the luxury of learning all day, and by God, we would not squander it on her watch. She ran that class as if we were on Parris Island, making us drop and give her twenty stanzas: “SIR, YES SIR! DYLAN THOMAS, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("FERN HILL,")]), _vm._v(" SIR!” We hated her.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But years later, I still remember "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Fern Hill,")]), _vm._v(" those last lines: "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Time held me green and dying / Though I sang in my chains like the sea.")]), _vm._v(" Dr. Sarge gave me discipline then and sustenance forever. I had required so much of the self"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("help books I’d read, but I had required nothing of myself.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All these insights smelled suspiciously like epiphanies. Suspicious is how I felt about epiphanies, because my own never lasted: I’d open my heart to humanity, and then some nimrod would block the napkin dispenser at Starbucks and I’d have to close it again. What good is a redemption story if you can’t stay redeemed? I put this "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_11",
      "title": "11"
    }
  }, [_vm._v("question to Roman Krznaric, one of the school’s founding faculty members.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“We do a course in mindfulness or we take a dance class, and we feel full of inspiration"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("but the feeling fades,” he said. “The reality is that we don’t ‘find’ meaning or direction but grow them, through the rough"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("and"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("tumble of life. There’s a lovely Leonardo da Vinci line"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("he declared that experience was his mistress. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("That’s")]), _vm._v(" how we learn, through experiment and change.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Experiment and change could take a long time, though, and writing a check takes a second"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("which may be why I once paid several hundred dollars for a class on how to breathe. When it was over, I stopped breathing in any kind of organized way, and I felt betrayed. I had shown up and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("paid.")]), _vm._v(" Wasn’t that enough? This is what happens in a free"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("market economy where we have little time and less patience, Krznaric told me: Once we’ve thrown money at a problem, we want an on"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("the"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("spot solution, preferably with a warranty. He said lightly, “You wanted to buy your happiness.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I thought about experiments"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("a cornerstone of the scientific method, as I learned in high school when we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_12",
      "title": "12"
    }
  }, [_vm._v("shattered our cryogenically frozen banana. No one performs an experiment once and considers her work done. She repeats it with different variables, correcting what she thought she knew, incorporating what she’s learned. Without tests, we’d never get to the facts. Why should it be so different with the truth?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The classes on creativity and ambition were packed, but there were only about fifteen students in How to Face Death. (They’d told me at the front desk that this one can be a hard sell.) One woman had come because her ninety"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("eight"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("year"), _c('span', {
    staticClass: "hyphen"
  }, [_vm._v("-")]), _vm._v("old mother was dying of cancer and refused to acknowledge it. A slightly graying man nodded to the woman beside him and said, “It’s our anniversary, and my wife thought this would be a nice way to end the week.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My own crisis of mortality had unspooled when my cat died, the year I turned forty. After the vet gave her that last shot, it was over so fast: She was there and then she wasn’t, and I was left holding her blankets. She’d been with me eighteen years. Living suddenly seemed more conditional than it had before. I couldn’t stand to put my ear to my husband’s chest, because his heart might stop beating while I lay there listening.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_13",
      "title": "13"
    }
  }, [_vm._v("In class we learned that the American education activist Parker J. Palmer once compared death to winter, which “clears the landscape.” Newcomers to the Upper Midwest, he wrote, are often advised: “The winters will drive you crazy until you learn to get out into them.” Walk straight ahead into winter"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("literal or metaphorical"), _c('span', {
    staticClass: "mdash"
  }, [_vm._v("—")]), _vm._v("or the dread of it will rule your life.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Our exercise, adapted from poet Stephen Levine’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Year to Live,")]), _vm._v(" was our walk into winter: We’d imagine that we were going to die in 365 days and plan the time we had left, month by month, conversations we’d like to have, things we’d longed to do.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’d always assumed I’d … travel. I’d travel to … where? I wrote “Asia” because that covered a lot of ground. I wrote “India,” and then put a question mark because it’s so hot. I looked at the blank spots on the page. Filling them would have to be my homework.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8dfc14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 75
// module chunks = 0